import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from '../../util/reactIntl';
import { useConfiguration } from '../../context/configurationContext';
import { Page, LayoutComposer } from '../../components';

import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

// Import Custom Homepage Sections
import HeroSection from '../../components/ChinaDolphins/HeroSection/HeroSection';
import AboutSection from '../../components/ChinaDolphins/AboutSection/AboutSection';
import HowItWorksSection from '../../components/ChinaDolphins/HowItWorksSection/HowItWorksSection';
import BenefitsSection from '../../components/ChinaDolphins/BenefitsSection/BenefitsSection';
import ContainerAggregationSection from '../../components/ChinaDolphins/ContainerAggregationSection/ContainerAggregationSection';

import css from './LandingPageChinaDolphins.module.css';
// import TrustandEscrowsection from '../../components/ChinaDolphins/TrustandEscrowSection/TrustandEscrowsection';
// import BecomePartner from '../../components/ChinaDolphins/BecomePartner/BecomePartner';
// import LetsBuildCTA from '../../components/ChinaDolphins/LetsBuildCTA/LetsBuildCTA';

/**
 * Custom ChinaDolphins Landing Page Container component
 */
const LandingPageChinaDolphins = props => {
  const { className, rootClassName, scrollingDisabled } = props;
  const intl = useIntl();
  const config = useConfiguration();

  const marketplaceName = config.marketplaceName;
  const title = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { marketplaceName });
  const description = intl.formatMessage({ id: 'LandingPage.schemaDescription' });

  const layoutAreas = `
    topbar
    main
    footer
  `;

  const classes = classNames(rootClassName || css.root, className);

  return (
    <Page
      title={title}
      description={description}
      scrollingDisabled={scrollingDisabled}
      className={classes}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {props => {
          const { Topbar, Main, Footer } = props;
          return (
            <>
              <Topbar as="header" className={css.topbar}>
                <TopbarContainer currentPage="LandingPage" />
              </Topbar>
              <Main as="main" id="main-content" className={css.main}>
                <HeroSection />
                <AboutSection />
                <HowItWorksSection className={'howItworks'} />
                <BenefitsSection />
                <ContainerAggregationSection />
                {/*
                <TrustandEscrowsection />
                <BecomePartner />
                <LetsBuildCTA />
                */}
              </Main>
              <Footer>
                <FooterContainer />
              </Footer>
            </>
          );
        }}
      </LayoutComposer>
    </Page>
  );
};

LandingPageChinaDolphins.defaultProps = {
  className: null,
  rootClassName: null,
  scrollingDisabled: false,
};

LandingPageChinaDolphins.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
  scrollingDisabled: PropTypes.bool,
};

export default LandingPageChinaDolphins;
